import React, { Component, Fragment } from "react";
import { Dialog } from "primereact/dialog";
import moment from "moment";
import * as PropTypes from "prop-types";
import { TabView, TabPanel } from 'primereact/tabview';
import ImageSlider from "../ImageSlider";
import AnaliseTemporalEmpreendimento from "../AnaliseTemporalEmpreendimento/AnaliseTemporalEmpreendimento";
import "./EmpreendimentoModal.css";

moment.locale("pt-br");

// Modal de detalhes do empreendimento EXCLUSIVO do MapBox (PrimeReact Dialog),
// com visual no tema Geobrain (verde). Isolado do modal do mapa Google.

const Item = ({ label, value, full }) => (
    <div className={"emp-item" + (full ? " emp-item--full" : "")}>
        <span className="emp-item__label">{label}</span>
        <span className="emp-item__value">{value === null || value === undefined || value === '' ? '—' : value}</span>
    </div>
);

const Section = ({ title, icon, grid = true, children }) => (
    <div className="emp-section">
        <h6 className="emp-section__title">{icon && <i className={icon} />}{title}</h6>
        {grid ? <div className="emp-grid">{children}</div> : children}
    </div>
);

class CardNegociacao extends Component {
    render() {
        const e = this.props.empreendimento;
        return (
            <Section title="Dados de Negociação" icon="fas fa-handshake">
                <Item label="Percentual de Entrada" value={`${e.porcentagem_entrada} %`} />
                <Item label="Número de Parcelas" value={e.numero_parcelas} />
                <Item label="Valor de Desconto à vista" value={`R$ ${e.valor_desconto}`} />
                <Item label="Percentual de Desconto" value={`${e.percentual_desconto} %`} />
                <Item label="Valor Parcela" value={`R$ ${e.valor_parcela}`} />
                <Item label="Taxa de Juros" value={`${e.taxa_juros} %`} />
                <Item label="Índice de Correção de Juros" value={e.indice_juros} />
                <Item label="Taxa Associativa" value={e.taxa_associativa} />
            </Section>
        );
    }
}

CardNegociacao.propTypes = { empreendimento: PropTypes.shape({ this: PropTypes.any }) };

class EmpreendimentoModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
            downloadProgress: 0
        };
    }

    renderHeader(empreendimento) {
        const isAtivo = empreendimento.status === 'Comercialização';
        return (
            <div className="emp-head">
                <div className="emp-head__icon"><i className="far fa-building"></i></div>
                <div className="emp-head__info">
                    <div className="emp-head__title">{empreendimento.nome}</div>
                    <div className="emp-head__subtitle">
                        {[empreendimento.tipo_empreendimento, empreendimento.padrao].filter(Boolean).join(' • ')}
                    </div>
                    <div className="emp-head__meta">
                        <span className={"emp-chip " + (isAtivo ? "emp-chip--ok" : "emp-chip--off")}>
                            <i className={isAtivo ? "fas fa-circle-check" : "fas fa-circle-xmark"}></i>
                            {empreendimento.status}
                        </span>
                        {empreendimento.retrofit == 1 && (
                            <span className="emp-chip emp-chip--retrofit">
                                <i className="fas fa-recycle"></i> Retrofit
                            </span>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const empreendimento = this.props.empreendimento;
        if (!empreendimento) return null;

        let periods = empreendimento.anexos.map((index) => index.created_at);
        periods = periods.filter((element, index) => periods.indexOf(element) === index);

        let periodsTabela = empreendimento.tabelas.map((index) => index.created_at);
        periodsTabela = periodsTabela.filter((element, index) => periodsTabela.indexOf(element) === index);

        let periodsMaterial = empreendimento.material.map((index) => index.created_at);
        periodsMaterial = periodsMaterial.filter((element, index) => periodsMaterial.indexOf(element) === index);

        let periodsMemorial = empreendimento.memorial.map((index) => index.created_at);
        periodsMemorial = periodsMemorial.filter((element, index) => periodsMemorial.indexOf(element) === index);

        let nome_empreendimento = empreendimento.nome;
        const enderecoCompleto = `${empreendimento.endereco}, ${empreendimento.numero} ${empreendimento.bairro}, ${empreendimento.cidade} - ${empreendimento.estado}`;
        const hasFotos = empreendimento.fotos.length > 0;

        const dialogFooter = (
            <div className="emp-footer">
                <a target="_blank" rel="noreferrer" className="emp-link-report"
                    href={"/contato-infos?empreendimento=" + empreendimento.id_legado}>
                    <i className="fas fa-circle-exclamation"></i> Informar dados faltantes ou incorretos
                </a>
                <div className="emp-footer__actions">
                    <button onClick={this.handleDownloadClick} className="emp-btn emp-btn--download"
                        disabled={this.state.downloading}>
                        {this.state.downloading
                            ? <><i className="fa fa-spinner fa-spin"></i> Baixando…</>
                            : <><i className="fa fa-file-pdf"></i> Download PDF</>}
                    </button>
                    <button className="emp-btn emp-btn--close" onClick={this.props.togglePainelEmpreendimento}>
                        Fechar
                    </button>
                </div>
            </div>
        );

        return (
            <Dialog
                visible={this.props.show}
                onHide={this.props.closeModalEmpreendimento}
                header={this.renderHeader(empreendimento)}
                footer={dialogFooter}
                className="mapbox-emp-dialog"
                style={{ width: '70vw', zIndex: 9999999 }}
                breakpoints={{ '1200px': '85vw', '768px': '95vw' }}
                contentStyle={{ maxHeight: '78vh' }}
                maximizable
                dismissableMask
            >
                <div className="mapbox-emp-modal">
                    <TabView scrollable>
                        {[
                        <TabPanel key="empreendimento" header="Empreendimento">
                            <div className={hasFotos ? "emp-two-col" : ""}>
                            {hasFotos && (
                                <div className="emp-photos">
                                    <ImageSlider images={empreendimento.fotos} />
                                </div>
                            )}
                            <div className="emp-info">

                            <Section title="Localização & Construção" icon="fas fa-location-dot">
                                <Item label="Endereço" value={enderecoCompleto} full />
                                <Item label="Construtora" value={empreendimento.construtora} full />
                            </Section>

                            {empreendimento.incorporadora && empreendimento.incorporadora.length > 0 && (
                                <Section title="Incorporadoras" icon="fas fa-briefcase" grid={false}>
                                    <div className="table-wrap">
                                        <table className="table table-condensed table-striped table-bordered tabela-emp mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Incorporadora</th>
                                                    <th>Participação</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {empreendimento.incorporadora.map((incorporator, index) => (
                                                    <tr key={index * 554554}>
                                                        <td>{incorporator.incorporadora}</td>
                                                        <td>{incorporator.participacao}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </Section>
                            )}

                            <Section title="Datas & Oferta" icon="fas fa-calendar-day">
                                <Item label="Database" value={empreendimento.database} />
                                {empreendimento.estagio && <Item label="Estágio" value={empreendimento.estagio} />}
                                <Item label="Data de Lançamento" value={empreendimento.lancamento} />
                                <Item label="Data de Entrega" value={empreendimento.entrega} />
                                <Item label="Oferta Lançada" value={empreendimento.oferta_inicial} />
                                <Item label="Oferta Final" value={empreendimento.oferta_final} />
                                <Item label="Disponibilidade s/ Oferta Lançada" value={`${Number(100 - empreendimento.porcentagem_vendida).toFixed(2)} %`} />
                                <Item label="Porcentagem Vendida" value={`${empreendimento.porcentagem_vendida} %`} />
                            </Section>

                            <Section title="Financeiro" icon="fas fa-coins">
                                <Item label="VGV Lançado" value={empreendimento.valor_geral_vendas_lancado} />
                                <Item label="VGV Final" value={empreendimento.valor_geral_vendas_final} />
                                <Item label="Preço Médio m²" value={empreendimento.valor_medio_metro} />
                                <Item label="Preço Médio" value={empreendimento.valor_medio_unidade} />
                                {empreendimento.ivv !== undefined && window.can_view_ivv &&
                                    <Item label="IVV" value={empreendimento.ivv} />}
                            </Section>
                            </div>
                            </div>
                        </TabPanel>,

                        (empreendimento.tipo_empreendimento == 'Horizontal') &&
                            <TabPanel key="dados_negociacao" header="Dados de Negociação">
                                <CardNegociacao empreendimento={empreendimento} />
                            </TabPanel>,

                        <TabPanel key="unidades" header="Unidades">
                            <Section title="Unidades" icon="fas fa-table-cells-large" grid={false}>
                                <div className="table-wrap">
                                    <table className="table table-condensed table-striped table-bordered tabela-emp mb-0"
                                        style={{ whiteSpace: 'nowrap' }}>
                                        <thead>
                                            <tr className="text-center">
                                                <th>Á. Privativa</th>
                                                <th>Quartos</th>
                                                <th>Vagas Garagem</th>
                                                <th>Tipologia</th>
                                                <th>Valor</th>
                                                <th>Valor m<sup>2</sup></th>
                                                <th>Of. Inicial</th>
                                                <th>Of. Final</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {empreendimento.unidades.map((unidade, index) => (
                                                <tr className="text-center" key={index * 785471578}>
                                                    <td>{unidade.area_privativa} m<sup>2</sup></td>
                                                    <td>{unidade.quartos}</td>
                                                    <td>{unidade.garagem}</td>
                                                    <td>{unidade.tipologia}</td>
                                                    <td>{unidade.valor}</td>
                                                    <td>{unidade.valor_metro} &nbsp; </td>
                                                    <td>{unidade.oferta_inicial}</td>
                                                    <td style={{ display: 'table-cell' }}>{unidade.oferta_final}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Section>
                        </TabPanel>,

                        (empreendimento.tipo_empreendimento != "Horizontal") &&
                            <TabPanel key="ficha" header="Ficha">
                                <Section title="Ficha Técnica" icon="fas fa-clipboard-list">
                                    <Item label="Torres" value={empreendimento.torres ?? 0} />
                                    <Item label="Andares" value={empreendimento.andares ?? 0} />
                                    <Item label="Elevadores" value={empreendimento.elevador ?? 0} />
                                    {empreendimento.areas.map((area, index) => {
                                        if (["Banheiros 1Q", "Banheiros 2Q", "Banheiros 3Q", "Banheiros 4Q"].includes(area.area)) {
                                            return <Item key={`span-areas-${index}`} label={area.area} value="Sim" />;
                                        }
                                        return null;
                                    })}
                                </Section>
                            </TabPanel>,

                        <TabPanel key="areas" header="Áreas de Lazer">
                            <Section title="Áreas de Lazer" icon="fas fa-tree" grid={false}>
                                <ul className="mb-0">
                                    {empreendimento.areas.map((area, index) => (
                                        <li key={`areaslazer-${index}`}>{area.area}</li>
                                    ))}
                                </ul>
                            </Section>
                        </TabPanel>,

                        (window.isInterno == true && empreendimento.anexos.length > 0) &&
                            <TabPanel key="anexos" header="Evidências">
                                <Section title="Evidências" icon="fas fa-paperclip" grid={false}>
                                    {periods.map((period, index) => (
                                        <Fragment key={`evidencias-${period}-${index}`}>
                                            <p className="mb-1">Evidências adicionadas no mês {period}</p>
                                            <ul className="list-group mb-3">
                                                {empreendimento.anexos.map((anexo, i) => anexo.created_at == period && (
                                                    <li className="list-group-item d-flex justify-content-between align-items-center" key={`anexos-evidencias-${i}`}>
                                                        <span>{anexo.name}</span>
                                                        <a className="btn btn-success btn-sm" href={anexo.url} target="_blank" rel="noreferrer">
                                                            <i className="fa fa-file-download"></i>
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </Fragment>
                                    ))}
                                </Section>
                            </TabPanel>,

                        (window.verMemorial == true && empreendimento.memorial.length > 0) &&
                            <TabPanel key="memorial" header="Memorial Descritivo">
                                <Section title="Memoriais" icon="fas fa-book" grid={false}>
                                    {periodsMemorial.map((period, index) => (
                                        <Fragment key={`material-period-${period}-${index}`}>
                                            <p className="mb-1">Memoriais Descritivos adicionados no mês {period}</p>
                                            <ul className="list-group mb-3">
                                                {empreendimento.memorial.map((anexo, i) => anexo.created_at == period && (
                                                    <li className="list-group-item d-flex justify-content-between align-items-center" key={`memorial-${i}`}>
                                                        <span>{anexo.name}</span>
                                                        <a className="btn btn-success btn-sm" href={anexo.url} target="_blank" rel="noreferrer">
                                                            <i className="fa fa-file-download"></i>
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </Fragment>
                                    ))}
                                </Section>
                            </TabPanel>,

                        (window.verMaterial == true && empreendimento.material.length > 0) &&
                            <TabPanel key="material" header="Materiais">
                                <Section title="Materiais" icon="fas fa-folder-open" grid={false}>
                                    {periodsMaterial.map((period, index) => (
                                        <Fragment key={`material2-periodo-${period}-${index}`}>
                                            <p className="mb-1">Materiais adicionados no mês {period}</p>
                                            <ul className="list-group mb-3">
                                                {empreendimento.material.map((anexo, i) => anexo.created_at == period && (
                                                    <li className="list-group-item d-flex justify-content-between align-items-center" key={`material-${i}`}>
                                                        <span>Material - {nome_empreendimento}</span>
                                                        <a className="btn btn-success btn-sm" href={anexo.url} target="_blank" rel="noreferrer">
                                                            <i className="fa fa-file-download"></i>
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </Fragment>
                                    ))}
                                </Section>
                            </TabPanel>,

                        (window.verAnexosEmpreendimento == true && empreendimento.tabelas.length > 0) &&
                            <TabPanel key="tabelas" header="Tabelas">
                                <Section title="Tabelas" icon="fas fa-file-invoice" grid={false}>
                                    {periodsTabela.map((period) => (
                                        <Fragment key={`tabelas-periodo-${period}`}>
                                            <ul className="list-group mb-3">
                                                {empreendimento.tabelas.map((anexo, i) => anexo.created_at == period && (
                                                    <li className="list-group-item d-flex justify-content-between align-items-center" key={`tabela-anexo-${i}`}>
                                                        <span>{nome_empreendimento} - {anexo.period}</span>
                                                        <a className="btn btn-success btn-sm" href={anexo.url} target="_blank" rel="noreferrer">
                                                            <i className="fa fa-file-download"></i>
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </Fragment>
                                    ))}
                                </Section>
                            </TabPanel>,

                        <TabPanel key="analise_temporal" header="Análise Temporal">
                            <AnaliseTemporalEmpreendimento empreendimento={empreendimento} />
                        </TabPanel>
                        ].filter(Boolean)}
                    </TabView>

                    {this.state.downloading && (
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" style={{ width: this.state.downloadProgress + '%' }}
                                aria-valuenow={this.state.downloadProgress} aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    )}
                </div>
            </Dialog>
        );
    }

    handleDownloadClick = async (event) => {
        event.preventDefault();

        try {
            await this.setState({ ...this.state, downloading: true, downloadProgress: 0 });

            const response = await fetch(this.props.empreendimento.pdf);

            if (!response?.body) {
                return;
            }

            const contentLength = response.headers.get('x-filesize');
            const totalLength = typeof contentLength === 'string' && parseInt(contentLength);

            const reader = response.body.getReader();
            const chunks = [];

            let receivedLength = 0;

            while (true) {
                const { done, value } = await reader.read();

                if (done) {
                    break;
                }

                chunks.push(value);
                receivedLength += value.length;

                let step = receivedLength / totalLength * 100;
                await this.setState({ ...this.state, downloadProgress: step });
            }

            const blob = new Blob(chunks);

            const fileNameFromResponse = response.headers.get('Content-Disposition').split('filename=')[1];

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');

            a.href = url;
            a.download = fileNameFromResponse;

            a.addEventListener('click', () => {
                setTimeout(() => {
                    URL.revokeObjectURL(url);
                    a.removeEventListener('click', () => { });
                }, 10000)
            }, false);

            a.click();
        } catch (e) {
            console.log(e);
        } finally {
            await this.setState({ ...this.state, downloading: false });
        }
    }
}

export default EmpreendimentoModal;
